function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.29 23.705l1.42-1.41L3.477 12 13.71 1.705 12.291.295.658 12l11.633 11.705z",
  fill: "#fff"
});

function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAxNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS42MzI0IDBMMTMuMDUxIDEuNDA5ODFMMi44MTk2OCAxMS43MDQ5TDEzLjA1MSAyMkwxMS42MzI0IDIzLjQwOThMMCAxMS43MDQ5TDExLjYzMjQgMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNjU4Mzg2IDIzLjcwNDYpIHNjYWxlKDEgLTEpIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgArrowLeft as ReactComponent };